export async function retry(fn, retryOptions) {
    const wrapped = () => new Promise((resolve, reject) => {
        try {
            resolve(fn());
        }
        catch (err) {
            reject(err);
        }
    });
    return retryAsync(wrapped, retryOptions);
}
export async function retryAsync(fn, { maxTry, delay }) {
    try {
        return await fn();
    }
    catch (err) {
        if (maxTry > 1) {
            await wait(delay);
            return await retryAsync(fn, { delay, maxTry: maxTry - 1 });
        }
        throw err;
    }
}
export function wait(duration) {
    return new Promise((resolve) => setTimeout(resolve, duration));
}
//# sourceMappingURL=retry.js.map